import React from 'react';
import PropTypes from 'prop-types';
import messages from '../../constants/messages';
import { validateLength, validateBlank } from '../../utils/validators';

const withInputValidation = (WrappedComponent) => {
  return class InputValidationHOC extends React.PureComponent {
    static get propTypes() {
      return {
        value: PropTypes.string,
        minLength: PropTypes.number,
        maxLength: PropTypes.number,
        allowBlank: PropTypes.bool,
        validator: PropTypes.func,
        validationError: PropTypes.string,
        emptyError: PropTypes.string,
        blankValidator: PropTypes.func,
        onValidate: PropTypes.func,
      };
    }

    static get defaultProps() {
      return {
        allowBlank: true,
      };
    }

    componentDidMount() {
      this.validate();
    }

    componentDidUpdate({
      value: prevValue,
      allowBlank: prevAllowBlank,
      maxLength: prevMaxLength,
      minLength: prevMinLength,
    }) {
      const { value, allowBlank, minLength, maxLength } = this.props;
      // Avoid unnecessary re-validation
      // when field value or validators was not actually changed
      if (
        prevValue !== value ||
        prevAllowBlank !== allowBlank ||
        prevMinLength !== minLength ||
        prevMaxLength !== maxLength
      ) {
        this.validate();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }

    validate() {
      const {
        value,
        minLength,
        maxLength,
        allowBlank,
        validator,
        validationError,
        emptyError,
        blankValidator = validateBlank,
        onValidate,
      } = this.props;

      let error;
      let isValidationError = false;

      if (value && validator && !validator(value)) {
        isValidationError = true;
        error = validationError || messages.validation.default;
      }
      if (value && (minLength || maxLength) && !validateLength(value, minLength, maxLength)) {
        error = messages.validation.lengthError(minLength, maxLength);
      }
      if (!allowBlank && !blankValidator(value)) {
        error = emptyError || messages.validation.blankField;
      }

      if (onValidate) {
        onValidate(error, isValidationError);
      }
    }
  };
};

export default withInputValidation;



// WEBPACK FOOTER //
// src/components/shared/withValidation.jsx